import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var heightVar = 'var(--fx_2d2fb1e5_123ve0h0)';
var root = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_123ve0h1',variantClassNames:{speed:{slow:'fx_2d2fb1e5_123ve0h2',quick:'fx_2d2fb1e5_123ve0h3'}},defaultVariants:{},compoundVariants:[]});

export { heightVar, root };
//# sourceMappingURL=dynamicHeightTransition.vanilla.mjs.map
